import XLSX from "xlsx-js-style";
import { convertSnapshotToXLSX } from "./convertSnapshotToExcel";

/**
 * Exporta um snapshot do Univer para Excel, opcionalmente adicionando metadados em uma nova sheet.
 * @param {Object} snapshot - O snapshot do Univer
 * @param {string} fileName - Nome do arquivo (sem extensão)
 * @param {Object} options - Opções de conversão
 * @param {Object} options.metadata - Objeto com metadados a serem incluídos (ex: { number, customer, start_date, ... })
 * @param {string} options.metadataSheetName - Nome da sheet de metadados (padrão: "Resumo")
 */
export function exportSnapshotToExcel(
  snapshot,
  fileName = "planilha",
  options = {},
) {
  const {
    metadata = null,
    metadataSheetName = "Resumo",
    metadataRows = [],
    labelMap = {},
    ...convertOptions
  } = options;

  // 1. Converte o snapshot para workbook
  const workbook = convertSnapshotToXLSX(snapshot, convertOptions);

  // 2. Se houver metadados, cria uma nova sheet com eles
  if (
    metadata &&
    typeof metadata === "object" &&
    Object.keys(metadata).length > 0
  ) {
    Object.keys(metadata).forEach((key) => {
      const label = labelMap[key] || key;
      const value = metadata[key] ?? "";
      metadataRows.push([label, value]);
    });

    // Cria a sheet de metadados
    const wsMetadata = XLSX.utils.aoa_to_sheet(metadataRows);
    // Ajusta largura das colunas
    wsMetadata["!cols"] = [{ wch: 20 }, { wch: 30 }];

    // Adiciona a sheet ao workbook (antes da primeira)
    XLSX.utils.book_append_sheet(workbook, wsMetadata, metadataSheetName);
    // Move a sheet para o início
    const sheetNames = workbook.SheetNames;
    const targetIndex = sheetNames.length - 1;
    workbook.SheetNames.splice(targetIndex, 1);
    workbook.SheetNames.unshift(metadataSheetName);
    // Reorganiza as sheets (preservando a ordem)
    const sheets = {};
    workbook.SheetNames.forEach((name) => {
      sheets[name] = workbook.Sheets[name];
    });
    workbook.Sheets = sheets;
  }

  // 3. Escreve o arquivo
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
}
